module.exports = __webpack_public_path__ + "static/media/product-labels.f5341cc8.png";